module.exports = __webpack_public_path__ + "images/line_friend_banner_f3c61458e4bd1c3c367dc3c09e2de46d.png";